/* eslint-disable jsx-a11y/anchor-is-valid */
import Head from 'next/head';
import Link from 'next/link';
import Image from 'next/image';
import Layout from '../../ui/layout';
import { Wrap } from '../../styled';
import awards from '../../constants/awards';
import features from './features';
import {
  Row,
  Column,
  ColumnInverted,
  Heading,
  Subheading,
  Text,
  Awards,
  AwardsItem,
  AwardsItemTitle,
  Features,
  FeaturesItem,
  FeaturesItemTitle,
  Flags,
  FlagsItem,
} from './styled';

import sizeEngine from './images/size-engine.jpg';

import ch from './images/flags/ch.svg';
import us from './images/flags/us.svg';
import pl from './images/flags/pl.svg';

const About = () => (
  <Layout>
    <Head>
      <title>Sizing solution for retailers and apparel brands.</title>
      <meta
        name="description"
        content="Increase conversions, reduce returns and personalize the shopping experience with EyeFitU size recommendations"
      />
      <meta
        property="og:title"
        content="Sizing solution for retailers and apparel brands."
      />
      <meta
        property="og:description"
        content="Increase conversions, reduce returns and personalize the shopping experience with EyeFitU size recommendations"
      />
    </Head>
    <Wrap>
      <Heading>About EyeFitU</Heading>
      <Subheading>EyeFitU is an award winning company.</Subheading>
      <Awards>
        {awards.map(({ name, title, image }) => (
          <AwardsItem key={name}>
            <Image
              src={image}
              style={{ objectFit: 'contain', height: 77 }}
              alt=""
            />
            <AwardsItemTitle>{title}</AwardsItemTitle>
          </AwardsItem>
        ))}
      </Awards>
      <Row>
        <ColumnInverted>
          <Text>
            We develop and manage technology solutions for the apparel industry
            via its patented <Link href="/how-it-works">SizeEngine™</Link>
          </Text>
        </ColumnInverted>
        <Column>
          <Image src={sizeEngine} width="649" height="353" alt="" />
        </Column>
      </Row>
      <Row>
        <Column>
          <Text>
            Isabelle Ohnemus and her team of engineers, data scientists, fashion
            and seasoned entrepreneurs work to enhance the competitiveness of
            fashion retailers: uplift their conversions, reduce their returns
            and use data intelligence to customize their offering and have a
            positive impact on their sustainable efforts.
          </Text>
        </Column>
        <Column>
          <Features>
            {features.map(({ img, title }) => (
              <FeaturesItem key={title}>
                <Image src={img} width="104" height="104" alt="" />
                <FeaturesItemTitle>{title}</FeaturesItemTitle>
              </FeaturesItem>
            ))}
          </Features>
        </Column>
      </Row>
      <Row>
        <ColumnInverted>
          <Text>
            We are headquartered in Zürich, Switzerland with offices in the USA
            and Poland.
          </Text>
        </ColumnInverted>
        <Column>
          <Flags>
            {[ch, us, pl].map((country) => (
              <FlagsItem key={country.src}>
                <Image src={country} width="154" height="93" alt="" />
              </FlagsItem>
            ))}
          </Flags>
        </Column>
      </Row>
    </Wrap>
  </Layout>
);

export default About;
